import React from 'react';
import { MenuItem, Stack, TextField } from '@mui/material';

type TrendFiltersProps = {
  search: string;
  category: string;
  categories: string[];
  designSubCategory?: string;
  designSubCategories?: string[];
  audience?: string;
  audiences?: string[];
  behavior?: string;
  behaviors?: string[];
  usageOccasion?: string;
  usageOccasions?: string[];
  onSearchChange: (value: string) => void;
  onCategoryChange: (value: string) => void;
  onDesignSubCategoryChange?: (value: string) => void;
  onAudienceChange?: (value: string) => void;
  onBehaviorChange?: (value: string) => void;
  onUsageOccasionChange?: (value: string) => void;
};

export default function TrendFilters({
  search,
  category,
  categories,
  designSubCategory = '',
  designSubCategories = [],
  audience = '',
  audiences = [],
  behavior = '',
  behaviors = [],
  usageOccasion = '',
  usageOccasions = [],
  onSearchChange,
  onCategoryChange,
  onDesignSubCategoryChange,
  onAudienceChange,
  onBehaviorChange,
  onUsageOccasionChange,
}: TrendFiltersProps) {
  return (
    <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} flexWrap="wrap" useFlexGap>
      <TextField
        fullWidth
        size="small"
        label="Sök"
        value={search}
        onChange={(event) => onSearchChange(event.target.value)}
      />
      <TextField
        select
        size="small"
        label="Kategori"
        value={category}
        onChange={(event) => onCategoryChange(event.target.value)}
        sx={{ minWidth: 220 }}
      >
        <MenuItem value="">Alla</MenuItem>
        {categories.map((entry) => (
          <MenuItem key={entry} value={entry}>
            {entry}
          </MenuItem>
        ))}
      </TextField>
      {onDesignSubCategoryChange && designSubCategories.length > 0 && (
        <TextField
          select
          size="small"
          label="Designspår"
          value={designSubCategory}
          onChange={(event) => onDesignSubCategoryChange(event.target.value)}
          sx={{ minWidth: 220 }}
        >
          <MenuItem value="">Alla</MenuItem>
          {designSubCategories.map((entry) => (
            <MenuItem key={entry} value={entry}>
              {entry}
            </MenuItem>
          ))}
        </TextField>
      )}
      {onAudienceChange && audiences.length > 0 && (
        <TextField
          select
          size="small"
          label="Målgrupp"
          value={audience}
          onChange={(event) => onAudienceChange(event.target.value)}
          sx={{ minWidth: 220 }}
        >
          <MenuItem value="">Alla</MenuItem>
          {audiences.map((entry) => (
            <MenuItem key={entry} value={entry}>
              {entry}
            </MenuItem>
          ))}
        </TextField>
      )}
      {onBehaviorChange && behaviors.length > 0 && (
        <TextField
          select
          size="small"
          label="Beteende"
          value={behavior}
          onChange={(event) => onBehaviorChange(event.target.value)}
          sx={{ minWidth: 220 }}
        >
          <MenuItem value="">Alla</MenuItem>
          {behaviors.map((entry) => (
            <MenuItem key={entry} value={entry}>
              {entry}
            </MenuItem>
          ))}
        </TextField>
      )}
      {onUsageOccasionChange && usageOccasions.length > 0 && (
        <TextField
          select
          size="small"
          label="Användningstillfälle"
          value={usageOccasion}
          onChange={(event) => onUsageOccasionChange(event.target.value)}
          sx={{ minWidth: 220 }}
        >
          <MenuItem value="">Alla</MenuItem>
          {usageOccasions.map((entry) => (
            <MenuItem key={entry} value={entry}>
              {entry}
            </MenuItem>
          ))}
        </TextField>
      )}
    </Stack>
  );
}
